module.exports = __webpack_public_path__ + "assets/visa.17821423.svg";